// Guarded so a second copy of this file on the page (the snippet used to emit one tag per footer
// menu) cannot bind a second click listener per title: an even number of listeners toggled the
// accordion open and shut again on every tap.
if (!window.__hbCollapsibleListInit) {
  window.__hbCollapsibleListInit = true;

  window.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".collapsible-title").forEach((trigger) => {
      trigger.addEventListener("click", function () {
        const content = this.parentElement.querySelector(".collapsible-content");
        content.classList.toggle("expanded");
        const isExpanded = content.classList.contains("expanded");
        content.inert = !isExpanded;
        this.setAttribute("aria-expanded", isExpanded);

        const openIcon = this.querySelector(".collapsible-icon.open");
        const closedIcon = this.querySelector(".collapsible-icon.closed");
        if (content.classList.contains("expanded")) {
          openIcon.style.display = "inline";
          closedIcon.style.display = "none";
        } else {
          openIcon.style.display = "none";
          closedIcon.style.display = "inline";
        }
      });
    });
  });
}
